import React, { useEffect } from "react"
import StateIntro from "../content/state_intro"
import AreaList from "../areas/AreaList"
import CTA from "../content/cta"


function States({ data }) {
  useEffect(() => {
    console.log(`data: ${JSON.stringify(data, null, 2)}`)
  })
  return (
    <>
      <StateIntro data={data}/>
      <AreaList areaList={data.citiesInState} areaName={data.area_name_full} areaCopy={`Top Service Areas In`} />
      <AreaList areaList={data.countiesInState} areaName={data.area_name_full} areaCopy={`Counties We Serve In`} />
      <CTA />
    </>
  )
}

export default States
